import { ColProps } from 'antd';
import clsx from 'clsx';
import { AntCol } from 'components/ant/AntCol';
import React from 'react';

import s from './shared.module.less';

export const ColFullPage: React.FC<ColProps> = ({ className, children, ...rest }) => (
  <AntCol {...rest} className={clsx(s.colFullPage, className)}>
    {children}
  </AntCol>
);
